import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const MeetingsViewRecordingsIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.75 12C4.5 8.25 7.75 6 12 6C16.25 6 19.5 8.25 21.25 12C19.5 15.75 16.25 18 12 18C7.75 18 4.5 15.75 2.75 12Z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="12"
      r="3"
      stroke="currentColor"
      strokeWidth="1.75"
    />
  </Icon>
);
